export const MODAL_ACTIVE_THEME_APP_EXTENSION = 'Thông báo bật theme app extension';
